import React from 'react';
import { CampaignNameFieldIcon } from './campaign-name-field.styles';
import { CAMPAIGN_NAME_FIELD_TEST_IDS, ICON_COLORS_BY_PLATFORM } from './campaign-name-field.constants';

interface CampaignNameFieldIconComponentProps {
    platform: string,
    Icon: Function,
}

export const CampaignNameFieldIconComponent = ({
    Icon,
    platform,
}: CampaignNameFieldIconComponentProps) => (
    <CampaignNameFieldIcon
        data-testid={CAMPAIGN_NAME_FIELD_TEST_IDS[platform]}
    >
        {
            Icon && (
                <Icon
                    size={19}
                    {...ICON_COLORS_BY_PLATFORM[platform]}
                />
            )
        }
    </CampaignNameFieldIcon>
);
